import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: pxToRem(16),
    fontSize: pxToRem(14),
  },
  title: {
    fontWeight: 600,
  },
});
